module.exports = __webpack_public_path__ + "wpicons.377ca18989bf84292e45.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/mattspringbett/sites/cycler/apollo-admin/src/src/assets/fonts/wpicons.woff2
// module id = ../../../../../src/assets/fonts/wpicons.woff2
// module chunks = 2